module.exports = __webpack_public_path__ + "img/support-banner.a6b5ad30.jpg";